import styled from "styled-components";
import { CloseOutlined } from "@ant-design/icons";
import { theme } from "@theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  
  border: 1px dashed rgba(228, 215, 205, 1);
  border-radius: 6px;
`

export const AddDateWrapper = styled.div`
  position: relative;
`

export const AddDateBtn = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  
  gap: 8px;
  font-size: 12px;
  color: rgba(57, 29, 10, 1);
  background: none;
  border: 1px solid rgba(198, 166, 145, 1);
  border-radius: 6px;
  padding: 8px;
  text-align: left;

  &:hover {
    cursor: pointer;
    background: rgba(240, 229, 222, 1);
  }
`

export const DatesWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;


  @media screen and (max-width: ${theme.breakpoints.sm}) {
    flex-wrap: wrap;
    div:nth-child(2) {
      flex: 1;
    }
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const ActionBtns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`

export const MoveBtns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const Btn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  
  width: 24px;
  height: 24px;
  font-size: 14px;
  cursor: pointer;
  
  color: rgba(198, 166, 145, 1);
  background: none;
  border: none;
  border-radius: 50%;
  
  &:hover {
    background: rgba(189, 152, 127, 0.2);
  }
`

export const DeleteButton = styled(Btn)`
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    align-self: center;
  }
`
